import api from '@shared/services/api.js';

export const getTokenData = async () => {
  return api.get('/analytics/api/auth');
};
